import { useMutation, UseMutationOptions, useQueryClient } from "@tanstack/react-query";
import { Profile } from "@/types";
import { api, UnprocessableEntityError } from "@/utils/api";
import { camelize, underscore } from "@/utils/api-helpers";

export type UpdateProfileInput = {
  firstName: string;
  lastName: string;
  phone?: string;
};

export const useUpdateProfile = (
  options: Omit<UseMutationOptions<Profile, UnprocessableEntityError, UpdateProfileInput, unknown>, "mutationFn"> = {}
) => {
  const queryClient = useQueryClient();

  return useMutation<Profile, UnprocessableEntityError, UpdateProfileInput, unknown>({
    mutationFn: async (input: UpdateProfileInput): Promise<Profile> => {
      const response = await api.patch<Profile>("/profile", underscore(input));
      return camelize(response.data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["profile"],
      });
    },
    ...options
  });
};
